import tw from 'tailwind-styled-components'
import {DivWithHint} from '@components/common/hint/hint'
import {cn} from '@containers/html-utils'
import {State} from './types'

export const TwBoardButton = tw(DivWithHint)<{
  $disabled?: boolean
  $forcedState?: State
  $noBorder?: boolean
}>`
  select-none
  px-12
  py-8
  h-32
  w-fit
  rounded-8
  text-sm-regular
  flex
  gap-4
  items-center
  justify-center
  ${p => {
    if (p.$disabled) {
      return cn('bg-background-disabled', 'text-action-disabled')
    }

    const cx: string[] = ['cursor-pointer', 'bg-background-primary']
    if (!p.$noBorder) {
      cx.push('shadow-border-1', 'shadow-line-base')
    }
    if (p.$forcedState === 'active') {
      cx.push('text-action-pressed')
    } else if (p.$forcedState === 'hover') {
      cx.push('text-action-default')
    } else if (p.$forcedState === 'default') {
      cx.push('text-secondary')
    } else {
      cx.push(
        'text-secondary',
        'hover:text-action-default',
        'active:text-action-pressed'
      )
    }
    return cx.join(' ')
  }}
`

export const TwText = tw.span`
  whitespace-nowrap
  overflow-hidden
  text-ellipsis
`
